import { useEffect, useState, forwardRef } from "react";
import { useSelector } from 'react-redux';
import { fetchApi } from '../../services/apiService';
import MultiSelectDropDown from "../form-components/MultiSelectDropDownComponent";
import MultiSelectDropDownForm from "../form-components/MultiSelectDropDownFormComponent";

const ItemAutocomplete = forwardRef((props, ref) => {
    const { allOption, selectedValues = [], editMode = false, onlyFuels = 'N', onlyTyres = 'N', onlyBatteries = 'N', onlyRefurbishable = 'N', onlyTaskInventory = 'N', disabled = false, forCategory = null, forSubCategory = null, forBrand = null, forVehicleModels = null, forAllItems = 'N', onlyBomEnabled = null, onlyLoginBranchMappedModelsItems = false, onlySerialNoApplicable = 'N', isFormikFormField = false, showFormError = false, ...rest } = props;
    let itemOptions = [];
    /* const getItemOptions = async (itemName) => {
        const getItemParams = {itemName};
        const response = await fetchApi('masters/getItems',getItemParams,userToken);
        console.log(response);
        if(response.status === 'Ok' && response.data.responseStatus === 'Ok'){
            let newOptions = [];
            if(response.data.items.length > 0){
                newOptions = newOptions.concat(response.data.items);
            }
            console.log(newOptions);
            return newOptions
        }
    } */
    let initialProps = {
        ...rest,
        labelKey: 'itemNameWithBrand',
        primaryKey: 'itemId',
        options: itemOptions,
        isObject: true,
        isFormikFormField,
        showFormError,
        // remoteData:true,
        // fetchRemoteDataHandler:getItemOptions,
        dataLoaded: false,
        editMode,
        disabled
    }
    const [defaultProps, setDefaultProps] = useState(initialProps);
    // Get Options
    const userToken = useSelector((state) => state.login.userToken);
    useEffect(() => {
        const getItemOptions = async () => {
            let getItemParams = {};
            if (forCategory && forCategory !== '') {
                getItemParams = { ...getItemParams, categoryId: forCategory }
            }
            if (forSubCategory && forSubCategory !== '') {
                getItemParams = { ...getItemParams, subCategoryId : forSubCategory }
            }
            if (forBrand && forBrand !== '') {
                getItemParams = { ...getItemParams, brandId: forBrand }
            }
            if (forVehicleModels && forVehicleModels !== '') {
                getItemParams = { ...getItemParams, vehicleModelIds: forVehicleModels }
            }
            if (onlyFuels && onlyFuels === 'Y') {
                getItemParams = { ...getItemParams, onlyFuels: onlyFuels }
            }
            if (onlyTyres && onlyTyres === 'Y') {
                getItemParams = { ...getItemParams, onlyTyres: onlyTyres }
            }
            if (onlyBatteries && onlyBatteries === 'Y') {
                getItemParams = { ...getItemParams, onlyBatteries: onlyBatteries }
            }
            if (onlyRefurbishable && onlyRefurbishable === 'Y') {
                getItemParams = { ...getItemParams, onlyRefurbishable: onlyRefurbishable }
            }
            if (onlyTaskInventory && onlyTaskInventory === 'Y') {
                getItemParams = { ...getItemParams, onlyTaskInventory: onlyTaskInventory }
            }
            if (onlyBomEnabled && onlyBomEnabled === 'Y') {
                getItemParams = { ...getItemParams, onlyBomEnabled: onlyBomEnabled }
            }
            if (forAllItems && forAllItems !== '') {
                getItemParams = { ...getItemParams, allItems: forAllItems }
            }
            if (onlyLoginBranchMappedModelsItems) {
                getItemParams = { ...getItemParams, onlyLoginBranchMappedModelsItems: true }
            }
            if (onlySerialNoApplicable && onlySerialNoApplicable === 'Y') {
                getItemParams = { ...getItemParams, onlySerialNoApplicable: onlySerialNoApplicable }
            }

            const response = await fetchApi('masters/getItems', getItemParams, userToken);
            if (response.status === 'Ok' && response.data.responseStatus === 'Ok') {
                let newOptions = [];
                if (response.data.items.length > 0) {
                    newOptions = newOptions.concat(response.data.items);
                }
                // let preSelectedValues = [newOptions[0]];
                let preSelectedValues = [];
                if (selectedValues.length > 0) {
                    preSelectedValues = newOptions.filter((i) => selectedValues.indexOf(i.itemId) >= 0);
                }
                const newProps = { ...defaultProps, options: newOptions, preSelectedValues, dataLoaded: true }
                setDefaultProps(newProps);
            }
        }
        getItemOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forCategory, forSubCategory, forBrand, forVehicleModels, onlyBomEnabled]);

    useEffect(() => {
        let preSelectedValues = [];
        if (selectedValues.length > 0) {
            preSelectedValues = defaultProps.options.filter((i) => selectedValues.indexOf(i.itemId) >= 0);
        }

        setDefaultProps({ ...defaultProps, editMode, preSelectedValues, dataLoaded: !editMode });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editMode]);

    useEffect(() => {
        const newProps = { ...defaultProps, disabled, dataLoaded: true }
        setDefaultProps(newProps);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled]);
    return (defaultProps.dataLoaded || editMode ?
        !isFormikFormField ?
            <MultiSelectDropDown
                ref={ref}
                {...defaultProps}
            /> :
            <MultiSelectDropDownForm
                ref={ref}
                {...defaultProps}
            /> : <></>
    );
});

export default ItemAutocomplete;